const LOCALE_TO_ICECAT_LANG: Record<string, string> = {
  'de-AT': 'DE_AT',
  'de-CH': 'DE_CH',
  'de-DE': 'DE',
  'es-ES': 'ES',
  'hr-HR': 'HR',
  'hu-HU': 'HU',
  'sk-SK': 'SK',
  'sl-SI': 'SL'
};

export const toIcecatLang = (locale: string): string => LOCALE_TO_ICECAT_LANG[locale] ?? 'DE';
